import { Entity, type EntityProps } from '../../../core/context/entity';

export enum CustomAttributeValueType {
    STRING = 'STRING',
    NUMBER = 'NUMBER',
    DATETIME = 'DATETIME',
    DATE = 'DATE',
}

export interface CustomAttributeProps extends EntityProps {
    label: string;
    type: string;
    isAsset: boolean;
    isSelected: boolean;
    isMandatory?: boolean;
    valueType?: CustomAttributeValueType;
    childrenIds?: string[];
}

export class CustomAttribute extends Entity implements CustomAttributeProps {
    label: string;
    type: string;
    isAsset: boolean;
    isSelected: boolean;
    valueType?: CustomAttributeValueType;
    isMandatory?: boolean;
    childrenIds?: string[];

    constructor({
        id,
        name,
        label,
        isMandatory,
        type,
        valueType,
        isAsset,
        isSelected,
        childrenIds,
    }: CustomAttributeProps) {
        super({ id, name });
        this.label = label;
        this.isMandatory = isMandatory;
        this.type = type;
        this.valueType = valueType;
        this.isAsset = isAsset;
        this.isSelected = isSelected;
        this.childrenIds = childrenIds;
    }
}
